import script from "./MyClients.vue?vue&type=script&setup=true&lang=js"
export * from "./MyClients.vue?vue&type=script&setup=true&lang=js"

import "./MyClients.vue?vue&type=style&index=0&id=1254ade5&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1254ade5"]])

export default __exports__